import { PublicLayout } from "@/components/layout/PublicLayout";
import { LEGAL_UPDATED } from "@/data/legal";

export const LegalPage = ({ title, intro, sections, testid }) => {
  return (
    <PublicLayout>
      <div className="mx-auto max-w-3xl px-6 py-20 md:py-28 lg:px-8" data-testid={testid}>
        <p className="font-heading text-xs font-semibold uppercase tracking-[0.25em] text-primary">
          Legal
        </p>
        <h1 className="mt-3 font-display text-5xl uppercase leading-none tracking-wide text-white sm:text-6xl">
          {title}
        </h1>
        <p className="mt-3 font-body text-sm text-zinc-500">Last updated: {LEGAL_UPDATED}</p>
        {intro && (
          <p className="mt-6 font-body leading-relaxed text-zinc-400">{intro}</p>
        )}

        <div className="mt-10 space-y-8">
          {sections.map((s) => (
            <section key={s.heading}>
              <h2 className="font-heading text-lg font-semibold tracking-tight text-white">
                {s.heading}
              </h2>
              <p className="mt-2 font-body leading-relaxed text-zinc-400">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
};
